import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useContext } from './Context'

export const MobileFilterButton = () => {
  const { setShowMobileFilter } = useContext()

  return <BusyButton title="Filter" className="d-lg-none" onClick={() => setShowMobileFilter(true)} icon="filter" />
}
